/**
 * @generated SignedSource<<71521ab6c90bb8a2a3e18367bfb79291>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AllStudentsFilterInput = {
  anyDiagnosticRetakeAssigned?: boolean | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  lastDiagnosticCompletedFrom?: any | null | undefined;
  lastDiagnosticCompletedTo?: any | null | undefined;
  onlyWithOutstandingDiagnostic?: boolean | null | undefined;
  onlyWithResetDiagnostic?: boolean | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  studentEmailContains?: string | null | undefined;
  studentEmails?: ReadonlyArray<string> | null | undefined;
  studentNameContains?: string | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type ReportHubOutstandingAssessmentsTotalQuery$variables = {
  filter: AllStudentsFilterInput;
};
export type ReportHubOutstandingAssessmentsTotalQuery$data = {
  readonly allStudents: {
    readonly totalCount: number;
  } | null | undefined;
};
export type ReportHubOutstandingAssessmentsTotalQuery = {
  response: ReportHubOutstandingAssessmentsTotalQuery$data;
  variables: ReportHubOutstandingAssessmentsTotalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentConnection",
    "kind": "LinkedField",
    "name": "allStudents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportHubOutstandingAssessmentsTotalQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportHubOutstandingAssessmentsTotalQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8d18fa5011d4dbecebbf04cb8e8fa338",
    "id": null,
    "metadata": {},
    "name": "ReportHubOutstandingAssessmentsTotalQuery",
    "operationKind": "query",
    "text": "query ReportHubOutstandingAssessmentsTotalQuery(\n  $filter: AllStudentsFilterInput!\n) {\n  allStudents(filter: $filter) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "ad6752e0cd9013e26ca815e8b0a534dd";

export default node;
